import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button } from '@checkmarx/cx-ui';
import copy from 'copy-to-clipboard';
import ReactTooltip from 'react-tooltip';

@inject('translationsStore', 'generatePasswordStore') @observer
class GeneratePasswordComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            generatedPassword: ''
        };
    };

    copyButtonWrapper = React.createRef();

    generateRandomPassword = async () => {
        const password = await this.props.generatePasswordStore.generatePasswordAction();
        return password;
    };

    generatePassword = async () => {
        const password = await this.generateRandomPassword();

        this.setState({
            generatedPassword: password
        });

        this.copyToClipboard(password);

        this.props.setGeneratedPassword(password);
    };

    copyToClipboard = (text) => {
        copy(text);
        const node = this.copyButtonWrapper.current;
        ReactTooltip.show(node);
        setTimeout(() => {
            ReactTooltip.hide(node);
        }, 2000);
    };

    render() {
        return (
            <div>
                <div>
                    <span
                        ref={this.copyButtonWrapper}
                        data-tip='tooltip'
                        style={{ display: 'inline-block', width: '100%' }}
                    >
                    </span>
                    <Button
                        type='button'
                        text={this.props.translationsStore.translate('GENERATE_AND_COPY_PASSWORD')}
                        onClick={this.generatePassword}
                        style={{ marginTop: '20px' }}
                    />
                </div>
                <ReactTooltip
                    type='success'
                    effect='solid'
                >
                    {this.props.translationsStore.translate('COPIED_TO_CLIPBOARD_TOOLTIP')}
                </ReactTooltip>
            </div>
        );
    }
}

export default GeneratePasswordComponent;